module.exports = __webpack_public_path__ + "img/IMG_8473_P_L_BlackMatted_MockedUp.73509900.jpg";